export default "__VITE_ASSET__cc8a4cfc__"